import { useStore } from 'base/store';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import { IHelpConfig, IHelpGroup, IHelpGroupConfig } from 'mod/help/interface';
import { useTrans } from 'base/utils/i18n';

function transGroupList(list: IHelpGroupConfig['list'], pages: IHelpConfig['pages'], conditions: Record<string, boolean>): IHelpGroup['list'] {
    const newList: IHelpGroup['list'] = [];
    list.forEach(item => {
        if (typeof item === 'string') {
            const page = pages[item];
            if (page) {
                newList.push({
                    title: page.title,
                    link: generatePath(RouteEnum.HELP, { code: item })
                });
            }
        } else if (typeof item.condition !== 'string' || conditions[item.condition]) {
            if('code' in item) {
                const page = pages[item.code];
                if (page) {
                    newList.push({
                        title: page.title,
                        link: generatePath(RouteEnum.HELP, { code: item.code })
                    });
                }
            } else {
                newList.push(item)
            }
        }
    });
    return newList;
}

export function useHelpGroups({ pages, groups }: IHelpConfig): IHelpGroup[] {
    const { t } = useTrans();
    const {
        persistStore: {
            state: { navList, referralConfig }
        },
        rootStore: {
            state: { country }
        }
    } = useStore();

    const conditions = {
        showReferrer: referralConfig.showReferralButton,
        countryDE: country === 'DE',
        notCountryDE: country !== 'DE',
        showEnBlog: country !== 'US' && country !== 'DE',
    };

    return [
        {
            key: 'Products',
            title: 'web_footer_link_products',
            list: navList.list?.map(item => ({
                title: item.title,
                link: item.link
            }))
        },
        ...groups.map(group => ({
            ...group,
            list: transGroupList(group.list, pages, conditions)
        }))
    ]
}